import { render, staticRenderFns } from "./FormControlUploadFile.vue?vue&type=template&id=6a3fab9f&scoped=true&"
import script from "./FormControlUploadFile.vue?vue&type=script&lang=js&"
export * from "./FormControlUploadFile.vue?vue&type=script&lang=js&"
import style0 from "./FormControlUploadFile.vue?vue&type=style&index=0&id=6a3fab9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3fab9f",
  null
  
)

export default component.exports